import { reportCardConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const saveReportCard = (form) => ({
    type: apiConstants.API,
    payload: {
        url: form.id ?
            url.recipientProgressReportCard.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId).replace(':reportCardId', form.id) :
            url.recipientProgressReportCards.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId),
        method: 'POST',
        body: form,
        request: () => ({ type: reportCardConstants.SAVING_REPORT_CARD_REQUEST }),
        success: (data) => ({ type: reportCardConstants.SAVING_REPORT_CARD_SUCCESS, data }),
        failure: (error) => ({ type: reportCardConstants.SAVING_REPORT_CARD_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0] }}),
        progress: {
            success: { message: () => 'Saved ReportCard.' }
        }
    }
});

export const deleteReportCard = ({ recipientId, progressId, reportCardId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressReportCard.replace(':recipientId', recipientId).replace(':progressId', progressId).replace(':reportCardId', reportCardId),
        method: 'DELETE',
        request: () => ({ type: reportCardConstants.DELETE_REPORT_CARD_REQUEST }),
        success: (data) => ({ type: reportCardConstants.DELETE_REPORT_CARD_SUCCESS, data }),
        failure: (error) => ({ type: reportCardConstants.DELETE_REPORT_CARD_FAILURE, error }),
        formatData: () => (progressId),
        progress: {
            request: { message: () => 'Deleting reportCard' },
            success: { message: () => 'Deleted reportCard.' }
        }
    }
});

export const loadReportCards = ({ recipientId, progressId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressReportCards.replace(':recipientId', recipientId).replace(':progressId', progressId),
        request: () => ({ type: reportCardConstants.LOAD_REPORT_CARDS_REQUEST }),
        success: (data) => ({ type: reportCardConstants.LOAD_REPORT_CARDS_SUCCESS, data }),
        failure: (error) => ({ type: reportCardConstants.LOAD_REPORT_CARDS_FAILURE, error })
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/reportCard.actions.js